import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { HeaderSection } from "../screens/ElementLight/sections/HeaderSection/HeaderSection";
import { PageSkeleton } from "../components/PageSkeleton/PageSkeleton";

const SiteFooter = lazy(() =>
  import("../components/SiteFooter").then((m) => ({ default: m.SiteFooter })),
);

function RouteFallback(): JSX.Element {
  // Always the compact page skeleton — never flash the home hero image on other routes.
  return <PageSkeleton variant="page" />;
}

/**
 * Shared chrome: sticky header is eager so route chunks can suspend
 * without the nav disappearing or the page jumping.
 */
export const AppLayout = (): JSX.Element => {
  return (
    <div className="flex flex-col min-h-screen">
      <HeaderSection />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Suspense fallback={null}>
        <SiteFooter />
      </Suspense>
    </div>
  );
};
